import { META } from './data';
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#1F1E1B] text-[#E5DDCB] relative overflow-hidden">
      {/* Pattern-paper grid lines for decoration */}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none" style={{ backgroundImage: 'linear-gradient(#E5DDCB 1px, transparent 1px), linear-gradient(90deg, #E5DDCB 1px, transparent 1px)', backgroundSize: '50px 50px' }} />
      <div className="relative max-w-[1500px] mx-auto px-8 lg:px-14 py-16 grid md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif text-3xl text-[#E5DDCB]" dangerouslySetInnerHTML={{ __html: META.brand }} />
          <p className="font-serif italic text-base text-[#E5DDCB]/55 mt-1">{META.tagline} · est. {META.est}</p>
          <p className="text-sm text-[#E5DDCB]/55 mt-5 leading-[1.7] max-w-md">A small house. Two cutters, four tailors, and a pressman who has been with us since 1989. Approximately one hundred and forty bespoke commissions a year.</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#6B2D2A] mb-3">House</p>
          <p className="text-sm text-[#E5DDCB]/85 leading-relaxed">14 Savile Row<br />Mayfair · London W1S 3PG</p>
          <p className="font-mono text-[11px] text-[#E5DDCB]/45 mt-2">+44 20 7493 0184</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#6B2D2A] mb-3">Trunk shows</p>
          <p className="text-sm text-[#E5DDCB]/85 leading-relaxed">New York · twice yearly<br />Hong Kong · annually<br />Geneva · annually</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#6B2D2A] mb-3">Cloth-makers</p>
          <ul className="text-sm text-[#E5DDCB]/85 space-y-1 leading-relaxed">
            <li>Holland & Sherry</li>
            <li>Loro Piana</li>
            <li>Fox Brothers</li>
            <li>Scabal</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E5DDCB]/15 px-8 lg:px-14 py-5 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#E5DDCB]/40">
        <span>© 2026 Ashford & Vail Limited · Bespoke since 1923 · A Savile Row House</span>
        <div className="flex gap-6">
          <button onClick={() => setPage('fittings')} className="hover:text-[#6B2D2A]">The Six Fittings</button>
          <a href="#" className="hover:text-[#6B2D2A]">Press</a>
          <a href="#" className="hover:text-[#6B2D2A]">Privacy</a>
        </div>
      </div>
    </footer>
  );
}
